"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinRevenueCenterSchema = exports.createFinRevenueCenterSchema = exports.finRevenueCenterShape = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (OP Billing Administration, Module 3 — Department/Revenue Mapping). Real Prisma model with zero HTTP exposure before this — the FK target every `FinDepartmentRevenueMapping` row needs. */
exports.finRevenueCenterShape = {
    code: zod_1.z.string().min(1).max(20),
    name: zod_1.z.string().min(1).max(255),
    parentRevenueCenterId: zod_1.z.string().uuid().optional(),
};
exports.createFinRevenueCenterSchema = zod_1.z.object(exports.finRevenueCenterShape);
exports.updateFinRevenueCenterSchema = zod_1.z.object(exports.finRevenueCenterShape).partial();
//# sourceMappingURL=fin-revenue-center.schema.js.map